import { createSlice } from '@reduxjs/toolkit'

export const documentsPurchasesSlice = createSlice({
  name: 'documentsPurchases',
  initialState: { data: [
    // { id: 1, src: '../images/docConsular.png', fileName: 'אישור קונסולרי.pdf', handleClick: handleClickConsular, permissions: [1, 3] },
    // { id: 2, src: '../images/docPurchase.png', fileName: 'טופס רכישה.pdf', handleClick: handleClickPurchase, permissions: [1, 3] },
    // { id: 3, src: '../images/docDeep.png', fileName: 'שטר קבר.pdf', handleClick: handleClickDeep, permissions: [1] },
  ] },
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
  },
})
export const documentsBurialsSlice = createSlice({
  name: 'documentsBurials',
  initialState: { data: [
    // { id: 1, src: '../images/document.png', fileName: 'טופס קבורה.pdf', handleClick: handleClickBurial, permissions: [0, 2] },
    // { id: 2, src: '../images/document.png', fileName: 'אישור קבורה.pdf', handleClick: handleClickDeep, permissions: [1, 3] },
  ] },
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
  },
})

export const documentsGeneralsSlice = createSlice({
  name: 'documentsGenerals',
  initialState: { data: [
    // { id: 1, src: '../images/docConsular.png', fileName: 'אישור נסיוני.pdf', handleClick: handleClickConsular, permissions: [1, 3] },
  ] },
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
  },
})
  
export const documentsPurchasesActions = documentsPurchasesSlice.actions
export const documentsBurialsActions = documentsBurialsSlice.actions
export const documentsGeneralsActions = documentsGeneralsSlice.actions
